import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DenversMostTrustedShield from "./sections/DenversMostTrustedShield";
import Serviceareas from "./sections/Serviceareas";
import OurSpecializedServices from "./sections/OurSpecializedServices";
import Customertestimonialsslider from "./sections/Customertestimonialsslider";
import TheProjectRoadmap from "./sections/TheProjectRoadmap";
import WatchfulEyes from "./sections/WatchfulEyes";
import CommonQuestions from "./sections/CommonQuestions";
import Crawlspacewarning from "./sections/Crawlspacewarning";
import Moistureprotectionhero from "./sections/Moistureprotectionhero";
import Blogresources from "./sections/Blogresources";
import Whyhomeownerstrustus from "./sections/Whyhomeownerstrustus";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      {}
      <DenversMostTrustedShield />
      {}
      <Whyhomeownerstrustus />
      {}
      <Serviceareas />
      {}
      <OurSpecializedServices />
      {}
      <Customertestimonialsslider />
      {}
      <TheProjectRoadmap />
      {}
      <WatchfulEyes />
      {}
      <CommonQuestions />
      {}
      <Crawlspacewarning />
      {}
      <Moistureprotectionhero />
      {}
      <Blogresources />
      <Footer />
    </div>;
}